export default {
  'Are you sure to delete the configuration item?': '确定删除配置项吗？',
  'Add configuration item': '添加配置项',
  'Quick configuration entry': '快捷配置入口',
  'Variable name': '变量名',
  'Variable grouping': '变量分组',
  'Variable title': '变量标题',
  'Variable description': '变量描述',
  'Variable type': '变量类型',
  'Dictionary data': '字典数据',
  'One line at a time, without quotation marks, for example: key1=value1':
    '一行一个，无需引号，比如：key1=value1',
  'Validation rules': '验证规则',
  'Extended properties': '扩展属性',
  'One attribute per line without quotation marks':
    '一行一个属性，无需引号，比如：class=config-item',
  weight: '权重',
  number: '数字',
  'Please enter the recipient email address': '请输入接收者邮箱地址',
  'Test mail sending': '测试邮件发送',
  'send out': '发送',
  'Please enter the correct email address': '请输入正确的电子邮箱地址',
  Sending: '发送中...',
  'Please enter the correct mail configuration': '请输入正确的邮件配置'
}
